import { useEffect, useState } from 'react';

const navItems = [
  { href: '#features', label: '观影特色' },
  { href: '#catalog', label: '精选片单' },
  { href: '#device', label: '多端适配' },
  { href: '#guide', label: '观看指南' },
  { href: '#ranking', label: '人气推荐' },
  { href: '#faq', label: '常见问题' },
  { href: '#entrance', label: '网址入口' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-background-50/70 backdrop-blur-sm border-b border-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-[72px] flex items-center justify-between gap-4">
        <a href="#top" className="flex items-center gap-2.5 shrink-0 group">
          <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-xl">
            <i className="ri-film-line" />
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-heading font-bold text-base md:text-lg text-foreground-950 tracking-tight">
              九七电影院
            </span>
            <span className="hidden sm:block text-[11px] text-foreground-500 tracking-widest">
              MOVIE ENTRANCE GUIDE
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="px-3 py-2 text-sm text-foreground-700 rounded-md hover:text-primary-700 hover:bg-primary-100/70 transition-colors whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#catalog"
            className="hidden md:inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-play-circle-line text-base" />
            查看精选片单
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开导航菜单"
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300/70 text-foreground-800 hover:bg-background-100 transition-colors"
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200/70 bg-background-50 px-4 py-3">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="px-3 py-3 text-sm text-foreground-800 rounded-md hover:bg-background-100 transition-colors"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}